import { gql } from "graphql-tag";

export const BRKT_TRANSACTIONS_QUERY = `
	query GetBrktTransactions($wallet: String!) {
		checkin(wallet: $wallet) {
			address
			transactions {
				created
				token
				amount
				amount_eq
				amount_brkt
				type
				scheduled_withdraw_time
				claimed_withdraw_time
				claimed
				salt
			}
		}
	}
`;
